import { render, staticRenderFns } from "./SpecialTopic.vue?vue&type=template&id=5f6c9500&scoped=true&"
import script from "./SpecialTopic.vue?vue&type=script&lang=js&"
export * from "./SpecialTopic.vue?vue&type=script&lang=js&"
import style0 from "./SpecialTopic.vue?vue&type=style&index=0&id=5f6c9500&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./SpecialTopic.vue?vue&type=style&index=1&id=5f6c9500&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6c9500",
  null
  
)

export default component.exports